import { connect } from 'react-redux'

export default connect(({
  app: {
    data: {
      userdata: {
        mygarage: {
          activeVehicleDetails: {
            vehicleName,
            vehicleNickname,
            makeDesc: make,
            modelDesc: model,
            yearDesc: year
          } = {}
        } = {}
      } = {}
    } = {}
  } = {}
}) => ({ activeVehicle: { vehicleName, vehicleNickname, make, model, year }}))
